import { render, staticRenderFns } from "./mainPage.vue?vue&type=template&id=55885a2c&scoped=true"
import script from "./mainPage.vue?vue&type=script&setup=true&lang=js"
export * from "./mainPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mainPage.vue?vue&type=style&index=0&id=55885a2c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55885a2c",
  null
  
)

export default component.exports